import { createGlobalStyle } from "styled-components";

export const FundraiserFontOverride = createGlobalStyle`
  body, * {
    font-family: ui-sans-serif,system-ui,sans-serif,"Apple Color Emoji","Segoe UI Emoji",Segoe UI Symbol,"Noto Color Emoji";
  }
`;
